import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";

const NavBar = () => {
  const [nav, setNav] = useState(false);

  const links = [
    {
      id: 1,
      link: "home",
    },
    {
      id: 2,
      link: "about",
    },
    {
      id: 3,
      link: "projects",
    },
    {
      id: 4,
      link: "skills",
    },
    {
      id: 5,
      link: "contact",
    },
  ];
//className="text-5xl font-signature ml-2" 
  return (
    <div className="flex justify-between items-center w-full h-20 px-4 text-black  fixed" style={{"backgroundColor":"#b2ebf2"}}>
      <div>
        
        <h1 style={{"fontFamily":"Helvetica","fontSize":"40px" ,"fontWeight":"bold"}}>Ravi Roshan</h1>
      </div>

      <ul className="hidden md:flex">
        {links.map(({ id, link }) => (
          <li
            key={id}
            className="px-4 cursor-pointer capitalize font-medium  hover:scale-105 duration-200"
          >
            <Link to={link} smooth duration={500}>
              {link}
            </Link>
          </li>
        ))}



        

        <li>
        <a
              href="https://drive.google.com/file/d/1QHYDpSBAnO6vOTgD9n6KE95oDfTwLxoN/view"  //add your resume here
              className="px-4 cursor-pointer capitalize font-medium  hover:scale-105 duration-200"
              download={true}
              target="_blank"
              rel="noreferrer"
            >
             {"Resume"}
            </a>
        </li>
      </ul>

      <div
        onClick={() => setNav(!nav)}
        className="cursor-pointer pr-4 z-10 text-gray-500 md:hidden"
      >
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {nav && (
        <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-200">
          {links.map(({ id, link }) => (
            <li
              key={id}
              className="px-4 cursor-pointer capitalize py-6 text-3xl"
            >
              <Link
                onClick={() => setNav(!nav)}
                to={link}
                smooth
                duration={500}
              >
                {link}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NavBar;
